import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

const initialState = {
  limit: localStorage.getItem('@footab/itemsCountPerPage') || 50,
  firebaseToken: localStorage.getItem('@footab/admin/firebaseToken'),
};

export const useMainStore = create(
  persist(
    immer((set, get) => ({
      ...initialState,
      setLimit: (limit) =>
        set((state) => {
          state.limit = limit;
        }),
      setFirebaseToken: (token) =>
        set((state) => {
          state.firebaseToken = token;
        }),
    })),
    {
      name: '@footab/admin/mainStore',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
